import React, { useContext, useEffect, useState } from 'react'
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm'
import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm'
import useBankAccountService from '../../../app/services/hooks/useBankAccount';
import { AppContext } from '../../../contexts/AppContext';
import { Bank } from '../../../app/models/Bank';
import { BankAccountDataForm, BankAccountType, defaultSocietyBankAccountDataForm } from '../../../app/models/BankAccountType';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { toast } from 'react-toastify';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import SocietyBankAccountForm from './forms/SocietyBankAccountForm';


interface Props {
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;
    societyId: number;
}

const SocietyBankAccountCreate = ({ onSaved, onCancel, onError, societyId }: Props) => {
    
    const { createSocietyBankAccount, storeSocietyBankAccount, fetchingCreateSocietyBankAccount, fetchingStoreSocietyBankAccount } = useBankAccountService()
    const { showLoading, hideLoading } = useContext(AppContext);

    const [banks, setBanks] = useState<Bank[]>([]);
    const [bankAccountTypes, setBankAccountTypes] = useState<BankAccountType[]>([]);
    const [errorFields, setErrorFields] = useState<Record<string, string[]>>();
    const [bankAccount, setBankAccount] = useState<BankAccountDataForm>({
        ...defaultSocietyBankAccountDataForm,
        society_id: societyId
    })

    useEffect(() => {
        if (showLoading) showLoading('loading', 'Cargando datos...');
        createSocietyBankAccount(societyId, {
            onSuccess: (response: ServiceResponse) => {
                setBanks(response.data.banks);
                setBankAccountTypes(response.data.account_types);
                if (hideLoading) hideLoading();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.error(response.message);
                if (onError) onError();
            }
        });
    }, []);

    const store = () => {
        if (showLoading) showLoading('loading', 'Guardando cuenta corriente...');
        storeSocietyBankAccount(bankAccount, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });
                toast.success(response.message, {
                    autoClose: 2500
                });
                if (onSaved) onSaved();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            },
            onFieldError: (errorFields: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setErrorFields(errorFields.data);
            }
        });
    };

    const cancel = () => {
        if (onCancel) onCancel();
    };

    return (
        <>
            <div className="row">
                <div className="col-12">
                    <SocietyBankAccountForm 
                        societyBankAccountForm={bankAccount} 
                        setSocietyBankAccountForm={setBankAccount} 
                        banks={banks} 
                        bankAccountTypes={bankAccountTypes} 
                        errorFields={errorFields}
                        fetchingBankAccounts={fetchingCreateSocietyBankAccount}
                    />
                </div>
            </div>
            <hr />
            <div className="row justify-content-end">
                <div className="col-auto">
                    <ButtonCancelForm callbackCancel={cancel} locked={fetchingStoreSocietyBankAccount} />
                </div>
                <div className="col-auto">
                    <ButtonSaveForm callbackSave={store} locked={fetchingStoreSocietyBankAccount} />
                </div>
            </div>
        </>
    )
}

export default SocietyBankAccountCreate
